import { SmsMessageTemplate } from "../sms-message-template/sms-message-template";

export class UrgeHandleRule {
  cconstructor() {
    this.urgeHandleAble = false;
    this.earlyTime = 0;
    this.intervalTime = 0;
    this.urgeMessageSubject = "{\"expr\":\"'催办审批：' + DefaultFunction.GetContextParameter(\\\"bizDefName\\\")\",\"sexpr\":\"\"}";
    this.urgeMessageContent = "{\"expr\":\"'请您尽快审批' + DefaultFunction.GetContextParameter(\\\"procInstCreatorName\\\") + '的' + DefaultFunction.GetContextParameter(\\\"bizDefName\\\") + '。'\",\"sexpr\":\"\"}";
    this.addReminder = false;
    this.subjectEditable = true;
    this.contentEditable = true;
  }

  urgeHandleAble: boolean;
  sendType: string;
  earlyTime: number;
  intervalTime: number;
  urgeMessageSubject: string;
  urgeMessageContent: string;
  // 是否添加催办人信息
  addReminder: boolean;
  subjectEditable: boolean;
  contentEditable: boolean;

  /**
   * 短信模板
   */
  smsMessageTemplate: SmsMessageTemplate
}
